import { Container } from 'typescript-ioc';
import { IRouter } from '../router';
import { TObject } from '../type-extensions';

export const useRouteParams = ():TObject<string> => {
    const routingService = Container.get(IRouter);
    const params = routingService.router.getState().params;

    return params || {};
};
